/** @jsxImportSource @emotion/react */
import { FEATURE_FLAGS } from '@app/app-constants'
import Navbar from '@app/components/ui/Navbar/Navbar'
import NavTriggerV2 from '@app/modules/HomeV2/components/SidebarToggleTrigger'
import { appLink } from '@app/config/appLink'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { clientNameAtom } from '@app/state/clientsAtom'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

const RiskNavbar = () => {
  const clientName = useAtomValue(clientNameAtom)

  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])
  const { useMultipleFeatureFlags } = useFeatureFlags()
  const isFeatureFlagsEnabled = useMultipleFeatureFlags([
    FEATURE_FLAGS.PRIORITISATION_PAGE,
    FEATURE_FLAGS.ADAPTATION_LIBRARY,
    FEATURE_FLAGS.RISK_PROFILE,
  ])

  return (
    <Navbar.Wrapper>
      <NavTriggerV2 />
      <Navbar.List>
        <Navbar.Item label="Overview" path={`${appLink.risk.path}/overview`} />
        {isFeatureFlagsEnabled[FEATURE_FLAGS.RISK_PROFILE] && (
          <Navbar.Item label="Profile" path={`${appLink.risk.path}/profile`} />
        )}
        <Navbar.Item label="Risk" path={`${appLink.risk.path}/explorer`} />
        <Navbar.Item label="Summary" path={`${appLink.risk.path}/summary`} />
        {isFeatureFlagsEnabled[FEATURE_FLAGS.PRIORITISATION_PAGE] && (
          <Navbar.Item label="Prioritisation" path={`${appLink.risk.path}/prioritisation`} />
        )}
        <Navbar.Item label="Stories" path={`${appLink.risk.path}/stories`} />
        {isFeatureFlagsEnabled[FEATURE_FLAGS.ADAPTATION_LIBRARY] && (
          <Navbar.Item
            label="Adaptation Library"
            path={`${appLink.risk.path}/adaptation-library`}
          />
        )}
      </Navbar.List>
      <Navbar.Logo>
        <img src={logos.full} alt="Logo" />
      </Navbar.Logo>
    </Navbar.Wrapper>
  )
}

export default RiskNavbar
